/** Patient self-registered online; staff must capture registration source on first service. */
export function patientNeedsRegistrationSourceCapture(patient?: {
	selfRegistrationPending?: boolean | null;
} | null): boolean {
	return patient?.selfRegistrationPending === true;
}
